import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export const useCollection = (key, endpoint, placeholderData = []) => {
  const query = useQuery({
    queryKey: [key],
    queryFn: async () => (await api.get(endpoint)).data,
    placeholderData,
    retry: 1,
  });
  // Falls back whenever the response isn't actually an array — covers the
  // backend being down, but also misconfigured API URLs where the request
  // silently resolves to this app's own HTML (e.g. missing backend URL
  // hitting the SPA catch-all rewrite) instead of failing outright.
  return { ...query, data: Array.isArray(query.data) ? query.data : placeholderData };
};
